import { useToast, Skeleton } from '@chakra-ui/react';
import * as Sentry from '@sentry/react';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { utils as commonUtils } from '@finley-technologies/common';

import { useGetUserActiveCreditFacilitiesQuery } from 'types/dashboard-core-gqlTypes.generated.d';

import {
  errorToastConfig,
  errorToastId,
} from 'packages/common-frontend/constants';
import { CalculationTerminologiesContainer } from 'packages/resources/ui/CalculationTerminologiesContainer';
import { useFeatureFlags } from '~/contexts/FeatureFlagProvider';

export const ResourcesCalculationTerminologiesRoute = () => {
  const flags = useFeatureFlags();
  const toast = useToast();
  const navigate = useNavigate();

  const { data: userData } = useGetUserActiveCreditFacilitiesQuery({
    /**
     *  Programmatically added onError handler.
     * @onError-TODO: Explicitly handle errors for this fetch
     */
    onError: (err) => {
      errorToastConfig.title = commonUtils.EnvUtils.isProduction()
        ? 'An unexpected error occurred. Please contact Finley for support.'
        : err.message;
      toast(errorToastConfig);
    },
    variables: {
      creditFacilitySlugsToHide: flags?.creditFacilitySlugsToHide ?? [],
    },
  });
  if (!userData || !userData.user) {
    return (
      <Skeleton
        data-testid="loading-resources-calculation-terminologies-route"
        height="600px"
      />
    );
  }

  const {
    user: { organizationId, organization: creditFacilities },
  } = userData;

  // Use this variable for errors that bubble up to the component level route
  // This ensures we only toast the error once when there are multiple errors
  // We should use Chakra's toast.isActive, or a react hook in general, but the state re-renders when there are multiple errors in a given error boundary
  let routeLevelError = false;
  return (
    <Sentry.ErrorBoundary
      onError={() => {
        if (!routeLevelError && !toast.isActive(errorToastId)) {
          errorToastConfig.title = `Failed to load resources calculation terminologies page`;
          routeLevelError = true;
          toast(errorToastConfig);
          navigate('/');
        }
      }}
    >
      <CalculationTerminologiesContainer
        organizationId={organizationId}
        creditFacilities={creditFacilities.creditFacilities}
      />
    </Sentry.ErrorBoundary>
  );
};
